import React from 'react';
import { PackagePricingLink } from '../projects/ProductCreateBanner';
import { canUseReadyApps, hasPublishSlotRemaining } from '../apps/readyAppQuota';
import { useI18n } from '../../hooks/useI18n';
import { useMyPackage } from '../../hooks/useMyPackage';
import { classNames } from '../../utils/classNames';

export const PublishSlotsUsage = () => {
  const { t, formatNumber } = useI18n();
  const entitlement = useMyPackage();

  if (!entitlement || !canUseReadyApps(entitlement)) {
    return null;
  }

  const max = Number(entitlement.maxActivePublishes ?? 0);
  const used = Number(entitlement.activePublishes ?? 0);
  const remaining = Number(entitlement.publishSlotsRemaining ?? Math.max(0, max - used));
  const isFull = remaining <= 0 || !hasPublishSlotRemaining(entitlement);

  return (
    <div
      className={classNames(
        'rounded-2xl border px-4 py-3 text-sm',
        isFull
          ? 'border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-900/40 dark:bg-rose-900/20 dark:text-rose-200'
          : 'border-neutral-200 bg-white text-neutral-700 dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-300'
      )}
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="font-semibold">{t('cloudPublishUsageLabel')}</p>
        <p dir="ltr" className="font-mono text-base font-bold tabular-nums">
          {t('cloudPublishUsageCount', {
            used: formatNumber(used),
            max: formatNumber(max)
          })}
        </p>
      </div>
      {isFull ? (
        <p className="mt-1.5 leading-6">
          {t('publishSlotsFull')}{' '}
          <PackagePricingLink>{t('upgradePlan')}</PackagePricingLink>
        </p>
      ) : null}
    </div>
  );
};
